import type {
  VehicleModel,
  VehicleModelEntity,
} from '~/domain/Insurance/vehicleModelEntity';
import type { VehicleModelResponseDTO } from '~/dto/Insurance/vehicleModelResponseDTO';

export const vehicleModelResponseMapper = ({
  success,
  resultData,
}: VehicleModelResponseDTO): VehicleModelEntity => {
  if (success && resultData.length > 0) {
    let vehicleModels: VehicleModel[] = resultData
      .filter((item) => !Number.isNaN(item.codigo) && Number(item.codigo) > 0)
      .map((item) => ({
        value: item.codigo,
        label: item.descricao,
      }));

    return <VehicleModelEntity>{
      success,
      vehicleModels: vehicleModels,
    };
  }
  return { success: false, vehicleModels: [] };
};
